import React from 'react'
import PropTypes from 'prop-types'

import RadioGroupContext from 'contexts/RadioGroupContext'

const RadioGroupProvider = ({
  name,
  value,
  onChange = () => {},
  onChangeData = () => {},
  children,
}) => {
  const [selectedValue, setSelectedValue] = React.useState()
  const [, setSelectedData] = React.useState()

  React.useEffect(() => {
    setSelectedValue(value)
  }, [setSelectedValue, value])

  const selectValue = (value, data) => {
    setSelectedData(data)
    setSelectedValue(value)

    onChange({ target: { name, value } })
    onChangeData(data)
  }

  return (
    <RadioGroupContext.Provider value={{ selectedValue, selectValue }}>
      {children}
    </RadioGroupContext.Provider>
  )
}

RadioGroupProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
}

export default RadioGroupProvider
